/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { EnumerationQuantityDtoQuantityUsageType } from './EnumerationQuantityDtoQuantityUsageType';
import {
    EnumerationQuantityDtoQuantityUsageTypeFromJSON,
    EnumerationQuantityDtoQuantityUsageTypeFromJSONTyped,
    EnumerationQuantityDtoQuantityUsageTypeToJSON,
} from './EnumerationQuantityDtoQuantityUsageType';
import type { EnumerationQuantityUsageDto } from './EnumerationQuantityUsageDto';
import {
    EnumerationQuantityUsageDtoFromJSON,
    EnumerationQuantityUsageDtoFromJSONTyped,
    EnumerationQuantityUsageDtoToJSON,
} from './EnumerationQuantityUsageDto';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { StateOfUse } from './StateOfUse';
import {
    StateOfUseFromJSON,
    StateOfUseFromJSONTyped,
    StateOfUseToJSON,
} from './StateOfUse';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';

/**
 * 
 * @export
 * @interface EnumerationQuantityDto
 */
export interface EnumerationQuantityDto {
    /**
     * 
     * @type {string}
     * @memberof EnumerationQuantityDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationQuantityDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof EnumerationQuantityDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationQuantityDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EnumerationQuantityDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EnumerationQuantityDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EnumerationQuantityDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationQuantityDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationQuantityDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof EnumerationQuantityDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof EnumerationQuantityDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof EnumerationQuantityDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof EnumerationQuantityDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof EnumerationQuantityDto
     */
    editingUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof EnumerationQuantityDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof EnumerationQuantityDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof EnumerationQuantityDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationQuantityDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof EnumerationQuantityDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {StateOfUse}
     * @memberof EnumerationQuantityDto
     */
    state?: StateOfUse;
    /**
     * 
     * @type {string}
     * @memberof EnumerationQuantityDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationQuantityDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationQuantityDto
     */
    description?: string | null;
    /**
     * 
     * @type {EnumerationQuantityDtoQuantityUsageType}
     * @memberof EnumerationQuantityDto
     */
    quantityUsageType?: EnumerationQuantityDtoQuantityUsageType | null;
    /**
     * 
     * @type {EnumerationQuantityUsageDto}
     * @memberof EnumerationQuantityDto
     */
    setupUsage?: EnumerationQuantityUsageDto;
    /**
     * 
     * @type {EnumerationQuantityUsageDto}
     * @memberof EnumerationQuantityDto
     */
    evaluationUsage?: EnumerationQuantityUsageDto;
    /**
     * 
     * @type {string}
     * @memberof EnumerationQuantityDto
     */
    $type?: EnumerationQuantityDtoTypeEnum;
}


/**
 * @export
 */
export const EnumerationQuantityDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoEnumerationDtoEnumerationQuantityDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationQuantityDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EnumerationQuantityDtoTypeEnum = typeof EnumerationQuantityDtoTypeEnum[keyof typeof EnumerationQuantityDtoTypeEnum];


/**
 * Check if a given object implements the EnumerationQuantityDto interface.
 */
export function instanceOfEnumerationQuantityDto(value?: unknown): value is EnumerationQuantityDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EnumerationQuantityDtoTypeEnum)[0];
}

export function EnumerationQuantityDtoFromJSON(json: any): EnumerationQuantityDto {
    return EnumerationQuantityDtoFromJSONTyped(json, false);
}

export function EnumerationQuantityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumerationQuantityDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'commentCount': !exists(json, 'commentCount') ? undefined : json['commentCount'],
        'commentAttachmentsCount': !exists(json, 'commentAttachmentsCount') ? undefined : json['commentAttachmentsCount'],
        'lastComment': !exists(json, 'lastComment') ? undefined : json['lastComment'],
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': !exists(json, 'possibleActions') ? undefined : (json['possibleActions'] === null ? null : (json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': !exists(json, 'creatorUser') ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'lastModifierUser': !exists(json, 'lastModifierUser') ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'editingUser': !exists(json, 'editingUser') ? undefined : UserCatalogDtoFromJSON(json['editingUser']),
        'editingTime': !exists(json, 'editingTime') ? undefined : json['editingTime'],
        'comments': !exists(json, 'comments') ? undefined : (json['comments'] === null ? null : (json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': !exists(json, 'isReferenced') ? undefined : json['isReferenced'],
        'isReferencedBy': !exists(json, 'isReferencedBy') ? undefined : (json['isReferencedBy'] === null ? null : (json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'state': !exists(json, 'state') ? undefined : StateOfUseFromJSON(json['state']),
        'name': json['name'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'quantityUsageType': !exists(json, 'quantityUsageType') ? undefined : EnumerationQuantityDtoQuantityUsageTypeFromJSON(json['quantityUsageType']),
        'setupUsage': !exists(json, 'setupUsage') ? undefined : EnumerationQuantityUsageDtoFromJSON(json['setupUsage']),
        'evaluationUsage': !exists(json, 'evaluationUsage') ? undefined : EnumerationQuantityUsageDtoFromJSON(json['evaluationUsage']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function EnumerationQuantityDtoToJSON(value?: EnumerationQuantityDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'commentCount': value.commentCount,
        'commentAttachmentsCount': value.commentAttachmentsCount,
        'lastComment': value.lastComment,
        'isAvailable': value.isAvailable,
        'origin': EntityOriginToJSON(value.origin),
        'creatorUser': UserCatalogDtoToJSON(value.creatorUser),
        'lastModifierUser': UserCatalogDtoToJSON(value.lastModifierUser),
        'editingUser': UserCatalogDtoToJSON(value.editingUser),
        'editingTime': value.editingTime,
        'comments': value.comments === undefined ? undefined : (value.comments === null ? null : (value.comments as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value.isReferenced,
        'isReferencedBy': value.isReferencedBy === undefined ? undefined : (value.isReferencedBy === null ? null : (value.isReferencedBy as Array<any>).map(ReferencingObjectDtoToJSON)),
        'state': StateOfUseToJSON(value.state),
        'name': value.name,
        'iuid': value.iuid,
        'description': value.description,
        'quantityUsageType': EnumerationQuantityDtoQuantityUsageTypeToJSON(value.quantityUsageType),
        'setupUsage': EnumerationQuantityUsageDtoToJSON(value.setupUsage),
        'evaluationUsage': EnumerationQuantityUsageDtoToJSON(value.evaluationUsage),
        '$type': value.$type,
    });
}

